
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { DistributorLead, DistributorOEMManagement } from 'src/app/models/distributor-model';
import { AuthService } from 'src/app/services/auth.service';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { EmailService } from 'src/app/services/email/email.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { OEM_ID } from 'src/app/utils/constants';

import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-distributor',
  templateUrl: './add-distributor.component.html',
  styleUrls: ['./add-distributor.component.scss']
})
export class AddDistributorComponent implements OnInit{
  adminAccountTypeId!: string;
  lead: boolean=false;
  oemId: string='';

 alreadyExistedCompanyName: string = '';
    editedCompanyName: string = '';
    alreadyChecked=false;
    isCompanyInputField: boolean = false;
    isSwalConfirmed: boolean = false;
    @ViewChild('checkCompanyName') checkCompanyName!: ElementRef;
    @ViewChild('checkEmailField') checkEmailField!: ElementRef;
    emailWarningMessage: string = '';
    isEmailInputField: boolean = false;
    alreadyCheckedEmail: boolean = false;
    alreadyExistedEmail: any = '';


constructor(@Inject(MAT_DIALOG_DATA) public data: any,private fb: FormBuilder,private distributorService: DistributorService,
private authService: AuthService,private dialogRef: MatDialogRef<AddDistributorComponent>,private localStorageService: LocalStorageService, private endCustomerService: EndCustomerService, private emailService: EmailService) { }

ngOnInit(): void {
  this.getAccountType();

  if (this.data && this.data.oemId) {
    this.oemId = this.data.oemId;
  } else {
    const id = this.localStorageService.getItem('oemId');
    this.oemId = id;
  }
    
}

cancelAddDistributor() {
  this.distributorForm.reset();
  this.dialogRef.close();
}

distributorForm = this.fb.group({
  firstName: ['', Validators.required],
  lastName: ['', Validators.required],
  companyName: ['', Validators.required],
  email: ['',[Validators.required, Validators.email]],
  phoneNumber: ['', Validators.required],
  address: ['', Validators.required],
  role: ["DISTRIBUTOR"],
  accountType: [''],
  network: true,
  logo: [null]
});

getAccountType() {
  this.authService.getAccounttypes('admin').subscribe((data: any) => {
    const adminAccountType = data.data.find((account: any) => account.accountType.name === 'admin');
    if (adminAccountType) {
      this.distributorForm.get('accountType')?.setValue(adminAccountType.id);
    } else {
     
    }
  });
}

createDistributor() {
  if (this.distributorForm.valid) {
    const formValues = this.distributorForm.value;
      const distributorData: DistributorOEMManagement = {

        firstName: formValues.firstName || '',
        lastName: formValues.lastName || '',
        companyName: formValues.companyName || '',
        email: formValues.email || '',
        phoneNumber: formValues.phoneNumber || '',
        address: formValues.address || '',
        role: formValues.role || '',
        accountType: formValues.accountType || this.adminAccountTypeId || '',
        network: true,
        oemId:this.oemId,
        logo: formValues.logo
      };
      this.distributorService.addDistributorOemManagement(distributorData).subscribe(
        response => {
          Swal.fire({
            icon: 'success',
            title: 'Distributor Created Successfully, will be displayed in your Network After they verify their email',
          });
        },
        error => {
         
          Swal.fire(
            'Error',
            error.error.message || 'Could not create distributor.',
            'error'
          );
        }
      );
      this.dialogRef.close();
  }
  else{
    Swal.fire('Error', 'Please fill all required fields.', 'error');
    
  }
  
}

onDragOver(event: DragEvent) {
  event.preventDefault();
}
uploadLogo(event:any, isDragAndDrop: boolean){
  
  event.preventDefault();
  let uploadData = new FormData();
  
  const file = (isDragAndDrop)? event?.dataTransfer.files[0] : event.target.files[0];
  if (file && file.size > 10 * 1024 * 1024) {
    Swal.fire({
        icon: 'error',
        title: 'File Size Exceeded',
        text: 'File should not exceed 10MB.',
    });
    return; // Exit the function if the file is too large
}
  uploadData.append('file', file);
  let randomNumber = Math.floor(Math.random() * 10) + 1
  uploadData.append('destinationKey', randomNumber+'');
  this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile,uploadData).subscribe(data=>{
    if(data && data?.data){
      this.distributorForm.get('logo')?.patchValue(data.data);
      
    }
  },error=>{
  })
}
clearProfile(){
  this.distributorForm.get('logo')?.reset();
}

isFocusOff(event: any) {
      if(event.target.value === '') {
        this.alreadyChecked = false;
        return;
  
      }
      
      if(!this.alreadyChecked) {
        this.distributorService.checkCompanyName(event.target.value).subscribe(res => {
        },
        error => {
          if (error.status === 409) { // Check for conflict status
            this.swalPopupAppeared(event);
            this.alreadyChecked = false;
            this.alreadyExistedCompanyName = event.target.value;
          } else {
          }
        }
      )
      }
    
    }
    swalPopupAppeared(event: any){
      Swal.fire({
        position : 'center',
        title: 'Warning',
        text: 'Company name already exists. Do you still want to continue?',
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor : 'white',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor : '#0f74a9',
        cancelButtonText: 'No',  
        cancelButtonColor : '#6c757d',
      }).then((result) => {
        if (result.isConfirmed) {
          this.isCompanyInputField = false;
          this.isFocusOn(event);
        } else if(result.isDismissed) {
          this.isCompanyInputField = true;
          this.isFocusOut(event);
        }
      })
    }
  
    isFocusOut(event: any){
      if(this.isCompanyInputField) {
        this.checkCompanyName.nativeElement.focus();
      }
    }
    editEvent(){
      this.isSwalConfirmed = false;
      if(this.alreadyChecked && this.isSwalConfirmed === false) {
        this.checkCompanyName.nativeElement.focus();
      }
    }
    isFocusOn(event: any) {
      if(this.isSwalConfirmed && this.alreadyChecked) {
        this.checkCompanyName.nativeElement.blur();
          this.checkEmailField.nativeElement.focus();
      }
    }
    isInputChange(event: any) {
      this.alreadyChecked = false;
      this.isSwalConfirmed = false;
      this.isCompanyInputField = false;
      
      if(event.target.value === '') {
      }
       else if(this.distributorForm?.get('companyName')?.value !== this.alreadyExistedCompanyName){
        this.isCompanyInputField = false;
        this.isFocusOut(event);
      } else if(this.distributorForm.get('companyName')?.value === this.alreadyExistedCompanyName){
        this.alreadyExistedCompanyName = this.distributorForm?.get('companyName')?.value || '';
        this.alreadyChecked = true;
        this.isSwalConfirmed = true;
        this.swalPopupAppeared(event);
      }
    }

    isInputChangeEmail(event: any) {
      this.alreadyCheckedEmail = false;
      this.isEmailInputField = false;
      
      if(event.target.value === '') {
      }
       else if(this.distributorForm?.get('email')?.value !== this.alreadyExistedEmail){
        this.isEmailInputField = false;
      } else if(this.distributorForm?.get('email')?.value === this.alreadyExistedEmail){
        this.alreadyExistedEmail = this.distributorForm?.get('email')?.value || '';
        this.alreadyCheckedEmail = true;
        this.swalPopupAppearedEmail(event);
      }
    }

    isFocusOffEmail(event:any){
      if(event.target.value === '') {
        this.alreadyCheckedEmail=false;
        return;
      }
      if(!this.alreadyCheckedEmail){
        this.emailService.checkEmailStatusExists(event.target.value, 'distributor').subscribe(res => {
        },
        error => {
          if (error.status === 409) {
            this.emailWarningMessage = "The provided email already exists. Please try again with a different email."
            this.swalPopupAppearedEmail(event);
            this.alreadyCheckedEmail = false;
            this.alreadyExistedEmail = event.target.value;
          } else if(error.status === 404) {
            this.emailWarningMessage = "This email is linked to a previously deleted account. Please use a different email to register."
            this.swalPopupAppearedEmail(event);
            this.alreadyCheckedEmail = false;
            this.alreadyExistedEmail = event.target.value;
          }
        }
      )
      }
    }

    swalPopupAppearedEmail(event: any){
      Swal.fire({
        position : 'center',
        title: 'Warning',
        text: `${this.emailWarningMessage}`,
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor : 'white',
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor : '#0f74a9',
      }).then((result) => {
         if(result.isConfirmed) {
          this.isEmailInputField = true;
        }
      })
    }
}
